import { v4 as uuidv4 } from 'uuid';

export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: 'switch',
    FormItemProps: {
      label: '开关',
      name: uuid,
    }
  }
};
